(() => {
  if (window.productDesignGalleryLoaded) return;
  window.productDesignGalleryLoaded = true;
  function initialize(root) {
    root.querySelectorAll('[data-design-gallery-rail]').forEach(rail => {
      if (rail.dataset.designReady) return;
      const scroller = rail.querySelector('.product__thumbs--scroller');
      const previous = rail.querySelector('[data-design-scroll="prev"]');
      const next = rail.querySelector('[data-design-scroll="next"]');
      if (!scroller || !previous || !next) return;
      rail.dataset.designReady = 'true';
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      function update() {
        previous.disabled = scroller.scrollTop <= 2;
        next.disabled = scroller.scrollTop + scroller.clientHeight >= scroller.scrollHeight - 2;
      }
      previous.addEventListener('click', () => scroller.scrollBy({ top: -scroller.clientHeight * .8, behavior: reduced.matches ? 'auto' : 'smooth' }));
      next.addEventListener('click', () => scroller.scrollBy({ top: scroller.clientHeight * .8, behavior: reduced.matches ? 'auto' : 'smooth' }));
      scroller.addEventListener('scroll', update, { passive: true });
      scroller.addEventListener('load', update, true);
      const observer = new ResizeObserver(update);
      observer.observe(scroller);
      update();
      function cleanup(event) {
        if (!event.target.contains(rail)) return;
        observer.disconnect();
        document.removeEventListener('shopify:section:unload', cleanup);
      }
      document.addEventListener('shopify:section:unload', cleanup);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
